import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTwitter12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconTwitter12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M9.976 4.743q.007.114.006.228C9.982 7.307 7.92 10 4.145 10v-.001A6.5 6.5 0 0 1 1 9.206q.243.025.488.026c.924 0 1.822-.267 2.548-.758-.878-.015-1.647-.508-1.916-1.228.307.051.624.041.926-.03C2.089 7.049 1.4 6.325 1.4 5.484V5.46c.285.137.605.213.931.221-.901-.519-1.18-1.552-.635-2.36C2.738 4.427 4.275 5.098 5.925 5.17c-.166-.614.06-1.257.593-1.689.827-.669 2.126-.635 2.903.077.46-.078.9-.223 1.303-.43-.153.41-.474.757-.902.978A4.6 4.6 0 0 0 11 3.827a3.9 3.9 0 0 1-1.024.916"
            />
        </svg>
    );
}
export default memo(IconTwitter12);
